function Home() {
    return (
        <div>
            <h2 className="text-3xl font-bold mb-6 text-gray-800">Welcome to OriginsBot</h2>

            {/* Invite Box */}
            <a
                href="https://discord.com/oauth2/authorize?client_id=1396944453167480992"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-[#5865F2] hover:bg-[#4752C4] transition-colors rounded-2xl p-6 mb-6 no-underline group"
            >
                <img
                    src="/img/ob.PNG"
                    alt="OriginsBot"
                    className="w-20 h-20 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-1">
                        Invite OriginsBot Today!
                    </h3>
                    <p className="text-blue-100 text-sm">
                        Click to add OriginsBot to your Discord server
                    </p>
                </div>
                <svg
                    className="w-6 h-6 text-white group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </a>

            {/* Description */}
            <div className="space-y-4">
                <p className="text-gray-700 text-lg leading-relaxed">
                    A fully fledged Origins only Discord bot for .com only verification, basic moderation,
                    logging and more.
                </p>

                <p className="text-gray-700 text-lg leading-relaxed">
                    OriginsBot boasts a verification ecosystem. Once you're verified with your Habbo
                    in one server using OriginsBot, you're verified in them all. Simple.
                </p>

                <div className="bg-gray-50 p-6 rounded-lg mt-6">
                    <h3 className="text-xl font-semibold mb-3 text-gray-800">Key Features</h3>
                    <ul className="space-y-2 text-gray-700">
                        <li className="flex items-start">
                            <span className="text-[#5865F2] mr-2">✓</span>
                            <span>Cross server verification system</span>
                        </li>
                        <li className="flex items-start">
                            <span className="text-[#5865F2] mr-2">✓</span>
                            <span>Origins COM only verification support</span>
                        </li>
                        <li className="flex items-start">
                            <span className="text-[#5865F2] mr-2">✓</span>
                            <span>Basic moderation</span>
                        </li>
                        <li className="flex items-start">
                            <span className="text-[#5865F2] mr-2">✓</span>
                            <span>Comprehensive logging system</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Home;